module.exports = __webpack_public_path__ + "static/img/zl_btn2.523d473.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/zl_btn2.png
// module id = +yUa
// module chunks = 7